import { useState, useMemo, useCallback, useContext } from 'react';
// import ReactEcharts from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import TypeChangeBtnGroup from '@/components/type_change_btn_group/TypeChangeBtnGroup';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
// import styles from './numbersTrend.less?modules';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { fmtThousand } from '@/utils/comUtil';
import { useIntl } from 'umi';
import { mulTimeDimensionMulIndexMulValue } from '@/utils/reportResponseUtil';

import { LineChart } from 'echarts/charts';
import {
  // GridSimpleComponent,
  // GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  // TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';
import dayjs from 'dayjs';

echarts.use([TitleComponent, CanvasRenderer, LineChart]);

// 图表容器样式与坐标轴格式化函数提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%' };
const fmtAxisThousand = (p) => {
  return fmtThousand(p);
};

const NumbersTrend = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const intl = useIntl();
  const { formatMessage } = intl;
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const [type, setType] = useState('WEEK');
  const { data, title } = props;

  const changeType = useCallback((v) => {
    setType(v);
  }, []);

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    let xData = [];
    let seriesData1 = [];
    let seriesData2 = [];
    let seriesData3 = [];
    let seriesData4 = [];
    const result = mulTimeDimensionMulIndexMulValue(data || []);
    if (type === 'WEEK') {
      for (let index = 7; index > 0; index--) {
        xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
      }
    } else {
      for (let index = 30; index > 0; index--) {
        xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
      }
    }
    xData.forEach((e) => {
      const allMemberItem = result[type]?.ALL_MEMBER?.find(
        (s) => s.LABEL === e,
      ) || { VALUE: 0 };
      seriesData1.push(allMemberItem.VALUE);
      const activeMemberItem = result[type]?.ACTIVE_MEMBER?.find(
        (s) => s.LABEL === e,
      ) || { VALUE: 0 };
      seriesData2.push(activeMemberItem.VALUE);

      const allVipMemberItem = result[type]?.VIP_NEW_MEMBER?.find(
        (s) => s.LABEL === e,
      ) || { VALUE: 0 };
      seriesData3.push(allVipMemberItem.VALUE);
      const activeVipMemberItem = result[type]?.VIP_ACTIVE_TRACKING?.find(
        (s) => s.LABEL === e,
      ) || { VALUE: 0 };
      seriesData4.push(activeVipMemberItem.VALUE);
    });
    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
      },
      legend: {
        data: [
          formatMessage({ id: 'ec.dashboard.n02.lbl03' }),
          formatMessage({ id: 'ec.dashboard.n02.lbl04' }),
          formatMessage({ id: 'ec.dashboard.n02.lbl06' }),
          formatMessage({ id: 'ec.dashboard.n02.lbl07' }),
        ],
        itemWidth: 10,
        itemHeight: 10,
        top: 0,
        icon: 'rect',
      },
      grid: {
        top: 35,
        left: 24,
        right: 24,
        bottom: 0,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData, //['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        axisLabel: {
          color: charts.xColor, //坐标值得具体的颜色
          fontSize: chartsFontSize.s03,
          // interval: function () {
          //   return true;
          // },
        },
        axisTick: false,
        axisLine: {
          lineStyle: {
            color: charts.axisLineColor,
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          axisTick: false,
          axisLine: false,
          axisLabel: {
            color: charts.yColor, //坐标值得具体的颜色
            fontSize: chartsFontSize.s03,
            formatter: fmtAxisThousand,
          },
          splitLine: {
            show: false, //去除网格线
            lineStyle: {
              color: charts.axisLineColor,
            },
          },
          // name: '新/活',
          name: formatMessage({ id: 'ec.dashboard.n02.lbl05' }),
          // nameRotate: 45,
          // nameGap: 15,
          nameTextStyle: {
            color: charts.yColor,
          },
          min: 0,
        },
      ],
      // color: charts.lineColorList,
      color: charts.lineColorAreaList,
      // series: seriesData,
      series: [
        {
          name: formatMessage({ id: 'ec.dashboard.n02.lbl03' }),
          type: 'line',
          // data: data[type].newMembers,
          data: seriesData1,
          smooth: true,
          yAxisIndex: 0,
          lineStyle: {
            width: 2.5,
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.45,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#3f51b5',
              },
              {
                offset: 1,
                color: '#ffffff',
              },
            ]),
          },
          emphasis: {
            focus: 'series',
          },
        },
        {
          name: formatMessage({ id: 'ec.dashboard.n02.lbl04' }),
          yAxisIndex: 0,
          type: 'line',
          data: seriesData2,
          smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 2.5,
          },
          areaStyle: {
            opacity: 0.45,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#54ace9',
              },
              {
                offset: 1,
                color: '#ffffff',
              },
            ]),
          },
          emphasis: {
            focus: 'series',
          },
        },
        {
          name: formatMessage({ id: 'ec.dashboard.n02.lbl06' }),
          type: 'line',
          data: seriesData3,
          smooth: true,
          yAxisIndex: 0,
          lineStyle: {
            width: 2.5,
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.45,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#c5c5c5',
              },
              {
                offset: 1,
                color: '#ffffff',
              },
            ]),
          },
          emphasis: {
            focus: 'series',
          },
        },
        {
          name: formatMessage({ id: 'ec.dashboard.n02.lbl07' }),
          yAxisIndex: 0,
          type: 'line',
          data: seriesData4,
          smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 2.5,
          },
          areaStyle: {
            opacity: 0.45,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#6779bf',
              },
              {
                offset: 1,
                color: '#ffffff',
              },
            ]),
          },
          emphasis: {
            focus: 'series',
          },
        },
      ],
    };
    return option;
  }, [
    data,
    type,
    chartsFontSize.s03,
    fontFamily,
    formatMessage,
    charts.xColor,
    charts.axisLineColor,
    charts.yColor,
    // charts.lineColorList,
    charts.lineColorAreaList,
  ]);

  return (
    <>
      <Head boxId={title}>
        <TypeChangeBtnGroup
          change={changeType}
          typeList={[
            {
              label: `7${formatMessage({ id: 'comm.date.lbl.02' })}`,
              value: 'WEEK',
            },
            {
              label: `30${formatMessage({ id: 'comm.date.lbl.02' })}`,
              value: 'MONTH',
            },
          ]}
        />
      </Head>
      <Body loading={props.loading} bizData={data}>
        {/* <div className={styles.box}>
          <div className={styles.TypeChangeBtnGroup}>
            <TypeChangeBtnGroup
              change={changeType}
              typeList={[
                { label: '7天', value: 'week' },
                { label: '30天', value: 'month' },
              ]}
            />
          </div>
        </div> */}
        <ReactEChartsCore
          echarts={echarts}
          lazyUpdate={true}
          option={chartOption}
          notMerge={true}
          style={CHART_STYLE}
          showLoading={false}
        />
        {/* <ReactEcharts
          style={{ width: '100%', height: '100%' }}
          option={echartsOptions || {}}
          notMerge={true}
          lazyUpdate={true}
          showLoading={false}
          // onEvents={onEvents}
        /> */}
      </Body>
    </>
  );
};
export default NumbersTrend;
